import { render } from "./Liquidations75ApprovalHistory.vue?vue&type=template&id=14554232"
import script from "./Liquidations75ApprovalHistory.vue?vue&type=script&lang=js"
export * from "./Liquidations75ApprovalHistory.vue?vue&type=script&lang=js"

import "./Liquidations75ApprovalHistory.vue?vue&type=style&index=0&id=14554232&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__